import type { JSX } from 'react';
import { DISEASE_BURDEN_LOD } from '@/constants/PatientDashboard/patientTimeline';
import type { PlacedBurdenMarker } from '@/types/PatientDashboard/PatientTimeline.types';
import AssayMarker from './AssayMarker';
import { formatChartValue } from './ChartLane.util';
import ChartValueMarker from './ChartValueMarker';

interface IProps {
  marker: PlacedBurdenMarker;
  isSeriesHovered: boolean;
  isDimmed: boolean;
}

export default function BurdenValueMarker({
  marker,
  isSeriesHovered,
  isDimmed,
}: IProps): JSX.Element {
  const colour = marker.isThreshold && isSeriesHovered
    ? DISEASE_BURDEN_LOD.hoverColour
    : marker.colour;

  return (
    <ChartValueMarker
      left={`${marker.x}%`}
      top={`${marker.y}%`}
      valuePlacement={marker.placement}
      valueShiftPx={marker.shiftPx}
      value={formatChartValue(marker.value)}
      colour={colour}
      markerDate={marker.date}
      markerId={marker.pointId}
      isDimmed={isDimmed}
      glyph={(
        <AssayMarker
          assay={marker.assay}
          colour={colour}
          isDetected={marker.isDetected}
        />
      )}
    />
  );
}
